import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { FileUpload } from "components/creation/FileUploader";
import useIsMobile from "components/hooks/useIsMobile";
import { Paperclip, X } from "lucide-react";
import theme from "theme";

export default ({
  file,
  removeUpload,
}: {
  file: FileUpload;
  removeUpload: (filename: string) => void;
}) => {
  const isMobile = useIsMobile();
  let isImage = file?.file?.type.startsWith("image/");
  let imageUrl = file?.file ? URL.createObjectURL(file?.file) : "";
  const [showRemoveButton, setShowRemoveButton] = useState(isMobile);

  if (!isImage && file?.url && file.contentType.startsWith("image/")) {
    isImage = true;
    imageUrl = file.url;
  }

  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        alignItems: "center",
        borderRadius: "8px",
        border: "1px solid #D4D4D4",
      }}
      onMouseEnter={() => setShowRemoveButton(true)}
      onMouseLeave={() => {
        setShowRemoveButton(false);
      }}
    >
      {isImage && (
        <Box
          component="img"
          sx={{
            height: "64px",
            width: "64px",
            objectFit: "cover",
            borderRadius: "6px",
          }}
          src={imageUrl}
        />
      )}

      {!isImage && (
        <Box
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            padding: "8px 14px 8px 12px",
          }}
        >
          <Paperclip size={16} color={theme.palette.text.tertiary} />
          <Typography
            variant="bodySmallHeavy"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            {file.filename}
          </Typography>
        </Box>
      )}

      {/* Show the X button on hover */}
      {showRemoveButton && (
        <IconButton
          sx={{
            position: "absolute",
            top: "-8px",
            right: "-8px",
            alignItems: "start",
            borderRadius: "50px",
            background: "white",
            border: (theme) => `1px solid ${theme.palette.border}`,

            "&:hover": { background: "white" },
          }}
          onClick={() => removeUpload(file.filename)}
        >
          <X
            size={isMobile ? 20 : 16}
            style={{
              margin: "2px",
              filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
            }}
          />
        </IconButton>
      )}
    </Box>
  );
};
